export const ratingsMenu = [
  "4 Stars & above",
  "3 Stars & above",
  "2 Stars & above",
  "1 Stars & above",
];

export const priceSortMenu = ["Price - Low to High", "Price - High to Low"];
